function updatePrices() {
	// Find all price containers that have a discount percentage
	const priceContainers = document.querySelectorAll('[data-discount-percent]');

	priceContainers.forEach(container => {
		const discountPercent = parseFloat(container.getAttribute('data-discount-percent'));

		// Skip if no valid discount percentage
		if (!discountPercent || discountPercent === 0) return;

		// Select only the first money element within this container
		const el = container.querySelector('.money');
		if (!el) return;

		// Skip if already processed
		if (el.classList.contains('discounted-processed')) return;

		const text = el.textContent.replace(/[^\d.]/g, ''); // remove non-numeric
		const oldPrice = parseFloat(text);
		if (isNaN(oldPrice)) return;

		// Calculate new discounted price
		const newPrice = oldPrice - (oldPrice * (discountPercent / 100));

		// Style and strike through the old price
		el.style.textDecoration = 'line-through';
		el.style.opacity = '0.6';
		el.style.fontSize = '13px'; // smaller than new
		el.style.color = '#8E8E8E';
		el.classList.add('discounted-processed');

		// Create the new price element
		const newPriceEl = document.createElement('div');
		newPriceEl.className = 'new-price';
		newPriceEl.style.color = '#d32f2f';
		newPriceEl.style.fontWeight = 'bold';
		newPriceEl.style.fontSize = '16px';
		newPriceEl.textContent = `Rs ${newPrice.toFixed(2)} LKR`;

		// Add new price below if not already added
		if (!el.parentElement.querySelector('.new-price')) {
			el.parentElement.appendChild(newPriceEl);
		}
    	const moneyEls = container.querySelectorAll(".money");
        const dividedPrice = (newPrice / 3).toFixed(2);
        moneyEls[1].innerText = `Rs ${dividedPrice}`;
        moneyEls[2].innerText = `Rs ${dividedPrice}`;
		console.log('moneyEls', moneyEls);
	});
}

updatePrices();
// Run 1 second after window fully loads, then every 5 seconds
window.addEventListener('load', () => {
	setTimeout(() => {
		updatePrices();
		setInterval(updatePrices, 5000);
	}, 1000);
});
